<template>
  <div class="waybillRecord">
    <div class="title">
      返程推荐<span>运单记录</span>
    </div>
    <div class="record_main">
      <el-table style="width: 100%"
                height="100%"
                :data="data.result"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                :default-expand-all="true"
                :span-method="arraySpanMethod"
                ref="multipleTable">
        <el-table-column prop="truckBidNo"
                         header-align="left"
                         align="left"
                         label="货源编号"
                         width="100">
          <template slot-scope="scope">
            <div class="table_title">
              <span>运单号：{{scope.row.companyOrderNo}}</span>
              <span>车辆运单号：{{scope.row.goodsNum}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="货主信息"
                         align="left">
        </el-table-column>
        <el-table-column header-align="center"
                         label="位置信息"
                         align="center">
        </el-table-column>
        <el-table-column header-align="center"
                         label="货源信息"
                         align="center">
        </el-table-column>
        <el-table-column header-align="center"
                         label="服务费信息">
        </el-table-column>
        <el-table-column header-align="center"
                         label="装卸车辆(吨)"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column header-align="center"
                         label="状态"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label=""
                         header-align="center"
                         align="center"
                         width="1"
                         type="expand">
          <template slot-scope="scope">
            <el-table style="width: 100%"
                      class="carview_table_detail"
                      :data="scope.row.listInfo">
              <el-table-column header-align="left"
                               align="left"
                               label=""
                               width="100">
                <template slot-scope="scope">
                  <div>{{scope.row.goodsNum}}</div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="left">
                <template slot-scope="scope">
                  <div>
                    <span>公司名称：</span>{{scope.row.userCompanyName}}
                  </div>
                  <div>
                    <span>联系人姓名：</span>{{scope.row.userCompanyLinkman}}
                  </div>
                  <div>
                    <span>联系电话：</span>{{scope.row.userCompanyIphone}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="left">
                <template slot-scope="scope">
                  <div>
                    <span>出发地：</span>
                    {{scope.row.departLand}}
                    {{scope.row.departLandDetails}}
                  </div>
                  <div>
                    <span>目的地：</span>
                    {{scope.row.destina}}{{scope.row.destinaDetails}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="left">
                <template slot-scope="scope">
                  <div>
                    <span>期望运费：</span>
                    {{scope.row.expectFreight}}
                  </div>
                  <div>
                    <span>炼厂名称：</span>
                    {{scope.row.destina}}
                  </div>
                  <div>
                    <span>原料：</span>
                    {{scope.row.material}}
                  </div>
                  <div>
                    <span>重量：</span>
                    {{scope.row.totalWeight}}吨
                  </div>
                  <div>
                    <span>罐体：</span>
                    <span v-if="scope.row.tankBody === 0">铝罐</span>
                    <span v-else-if="scope.row.tankBody === 1">铁罐</span>
                    <span v-else-if="scope.row.tankBody === 2">白钢罐</span>
                    <span v-else-if="scope.row.tankBody === 3">铝合金罐</span>
                    <span v-else-if="scope.row.tankBody === 4">其他</span>
                  </div>
                  <div>
                    <span>货源有效期：</span>
                    {{scope.row.startTime}}至{{scope.row.endTime}}
                  </div>

                </template>

              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.roleType!== '0'">
                    <div class="typeInline">
                      <span>付款方：</span>
                      <div v-if="scope.row.roleType==='0'">物流公司</div>
                      <div v-else-if="scope.row.roleType==='1'">个人车主</div>
                      <div v-else-if="scope.row.roleType==='3'">物流中介</div>
                    </div>
                    <div>
                      <span>已支付：</span>
                      {{scope.row.driverPaySum}}
                    </div>
                    <div class="typeInline">
                      <span>支付状态：</span>
                      <div v-if="scope.row.driverPay === '0'">未支付</div>
                      <div v-if="scope.row.driverPay === '1'">已支付</div>
                      <div v-if="scope.row.driverPay === '2'">支付失败</div>
                    </div>
                  </div>
                  <div v-else-if="scope.row.roleType!=='0'">
                    没有服务费
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="center"
                               width="100">
                <template slot-scope="scope">
                  <div>
                    <span>装车量：</span>{{scope.row.unloadNum}}吨
                    <p v-if="scope.row.orderState==='0'|scope.row.orderState==='3'"
                       class="loadimgBtn">(暂未上传)</p>
                    <p v-else-if="scope.row.orderState!=='0'"
                       @click="handleGetimg(0, scope.row.driverOrderId)"
                       class="loadimgBtn">
                      查看图片
                    </p>
                  </div>
                  <div>
                    <span>卸车量：</span>{{scope.row.unloadNum}}吨
                    <p v-if="scope.row.orderState==='2'"
                       @click="handleGetimg(1, scope.row.driverOrderId)"
                       class="loadimgBtn">
                      查看图片
                    </p>
                    <p v-else-if="scope.row.orderState !=='2'"
                       class="loadimgBtn">(暂未上传)</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column header-align="center"
                               label=""
                               align="center"
                               width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.orderState==='0'">待运输</div>
                  <div v-else-if="scope.row.orderState==='1'">运输中</div>
                  <div v-else-if="scope.row.orderState==='2'">运输完成</div>
                  <div v-else-if="scope.row.orderState==='3'">已取消</div>
                </template>
              </el-table-column>

              <el-table-column label=""
                               header-align="center"
                               align="center"
                               width="120">
                <template slot-scope="scope">
                  <div class="statusInfo">
                    <div @click="handleTrackClick(scope.row.driverOrderId)">
                      查看轨迹
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="titlename"
               :visible.sync="loadCar"
               class="loadCarImg">
      <el-carousel trigger="click"
                   arrow="always"
                   indicator-position='none'
                   :autoplay="false">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div class="imgMain">
            <img :src=item
                 alt="">
          </div>
          <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <div class="trackMask"
         v-show="track"
         @click="handleCloseMapClick">
    </div>
    <div class="trackContainer"
         v-show="track">
      <div class="track_header">运输轨迹<span class="track_close"
              @click="handleCloseMapClick"></span></div>
      <div class="track_main">
        <div id="track_container"></div>
      </div>
    </div>
  </div>
</template>
<script src="https://webapi.amap.com/maps?v=1.4.13&key=6656a8e9810da0328783e4c374223568"></script>
<script>
import {
  getWaybillRecord,
  driverOrderImages,
  waybillTrack
} from 'apis/index'
export default {
  data () {
    return {
      routeId: '',
      data: {
      },
      getRowKeys (row) {
        return row.id
      },
      expands: [],
      loadCar: false,
      imgList: [],
      titlename: '',
      track: false,
      lnglatInfo: {}

    }
  },
  methods: {
    getData () { // 初始化页面
      getWaybillRecord({
        routeReturnId: this.routeId
      }).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data)
          this.data = res.data.data
          this.data.result.forEach((element, key) => {
            let items = element
            element.listInfo = [items]
          })
        } else if (res.data.code === 30016) {
          console.log('暂无运单量')
        }
      })
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 8]
      } else if (columnIndex === 1) {
        return [0, 0]
      }
    },
    toggle (row) { // 投标详情展示下拉列表
      this.$refs.multipleTable.toggleRowExpansion(row)
      row.onoff = !row.onoff
    },
    handleGetimg (types, driverOrderId) { // 获取图片
      this.titlename = types === 0 ? '装车量' : '卸车辆'
      driverOrderImages({
        types: types,
        driverOrderId: driverOrderId
      }).then(res => {
        this.loadCar = true
        if (res.data.code === 0) {
          this.imgList = []
          res.data.data.result.forEach(element => {
            this.imgList.push(element.imgUrl)
          })
        }
      })
    },
    handleTrackClick (driverOrderId) {
      // console.log(driverOrderId)
      this.track = true
      waybillTrack({
        driverOrderId: driverOrderId
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.lnglatInfo = res.data.data
          let startPoint = [this.lnglatInfo.destinaLatLng.split(',')[1], this.lnglatInfo.destinaLatLng.split(',')[0]]
          let endPoint = [this.lnglatInfo.departLatLng.split(',')[1], this.lnglatInfo.departLatLng.split(',')[0]]
          let trackPoint = []
          this.lnglatInfo.list.forEach(element => {
            trackPoint.push([element.split(',')[1], element.split(',')[0]])
          });
          var trackmap = new AMap.Map('track_container', {
            resizeEnable: true,
            center: trackPoint[trackPoint.length - 1],
            zoom: 9
          })
          var track_marker = new AMap.Marker({
            map: trackmap,
            position: trackPoint[0],
            icon: 'http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI',
            offset: new AMap.Pixel(-2, -5),
            autoRotation: true,
            angle: -90
          })
          // var polyline = new AMap.Polyline({
          //   map: trackmap,
          //   path: trackPoint,
          //   showDir:true,
          //   strokeColor: "#28F",  //线颜色
          //   strokeOpacity: 1,     //线透明度
          //   strokeWeight: 6,      //线宽
          //   // strokeStyle: "solid"  //线样式
          // });
          var passedPolyline = new AMap.Polyline({
            map: trackmap,
            path: trackPoint,
            strokeColor: '#28F', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          track_marker.moveAlong(trackPoint, 9009000)
          var startIcon = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(25, 34),
            // 图标的取图地址
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            // 图标所用图片大小
            imageSize: new AMap.Size(135, 40),
            // 图标取图偏移量
            imageOffset: new AMap.Pixel(-9, -3)
          })
          // 将 icon 传入 marker
          var startMarker = new AMap.Marker({
            position: startPoint,
            icon: startIcon,
            offset: new AMap.Pixel(-13, -30)
          })
          // 创建一个 icon
          var endIcon = new AMap.Icon({
            size: new AMap.Size(25, 34),
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            imageSize: new AMap.Size(135, 40),
            imageOffset: new AMap.Pixel(-95, -3)
          })

          // 将 icon 传入 marker
          var endMarker = new AMap.Marker({
            position: endPoint,
            icon: endIcon,
            offset: new AMap.Pixel(-13, -30)
          })
          trackmap.add([startMarker, endMarker])
        }
      })
    },
    handleCloseMapClick () {
      this.track = false
    }

  },
  mounted () {
    this.routeId = this.$route.query.item
    if (this.routeId) {
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.waybillRecord
  background #f7f9fb
  padding 0 20px
  font-size 12px
  min-width 818px
  height 100%
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 55px #F7F9FB
    span
      color #212832
      margin-left 20px
  .record_main
    height calc(100% - 70px)
    .el-table
      tr
        background #E6F3FE
        &:hover
          background #E6F3FE
      th
        background #e7f0f8
        .cell
          size12()
      td
        size12()
        .table_title
          span
            margin-right 60px
        .loadimgBtn
          color #1B88EE
          text-decoration underline
          cursor pointer
        .statusInfo
          div
            margin 0 auto
            width 78px
            height 28px
            line-height 28px
            background #1B88EE
            border-radius 3px
            color #fff
            cursor pointer
          .canceled
            background #CFD5DC
            cursor auto
            border-radius 3px
        .carviewlist
          div
            display inline
        .btna
          btna()
        .carview_table_detail
          width 100%
          // background #f7f9fb
          background #000
          th
            background #fff
            height 1px
            .cell
              size12()
          tr
            background #fff
            border-bottom 1px solid #f66
            .typeInline
              div
                display inline-block
          .el-table__header-wrapper
            display none
    .el-table__body-wrapper
      background #f7f9fb
  .el-dialog
    width 688px
    .el-dialog__header
      height 42px
      padding 0 20px 0
      text-align left
      background #1b88ee
      line-height 42px
      .el-dialog__title
        font-size 13px
        color #fff
    .el-dialog__headerbtn
      top 12px
      right 12px
      .el-dialog__close
        color #fff
        font-size 20px
    .el-dialog__body
      height 404px
      padding 12px
      .el-carousel
        width 100%
        height 100%
        .el-carousel__container
          width 348px
          height 350px !important
          margin 0 auto
        .el-carousel__arrow--left
          left -70px
          width 21px
          height 38px
          background url('../../../../assets/images/02/left_n_page.png') no-repeat
          &:hover
            background url('../../../../assets/images/02/left_h_page.png') no-repeat
        .el-icon-arrow-right:before
          content '' !important
        .el-carousel__arrow--right
          right -70px
          width 21px
          height 38px
          background url('../../../../assets/images/02/righe_n_page.png') no-repeat
          &:hover
            background url('../../../../assets/images/02/right_h_page.png') no-repeat
        .el-icon-arrow-left:before
          content '' !important
        .imgMain
          width 348px
          height 350px
          position relative
          img
            width 100%
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
        .imgNums
          position absolute
          bottom 10px
          left 50%
          transform translatex(-50%)
  .trackMask
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    background rgba(0, 0, 0, 0.4)
    z-index 200
  .trackContainer
    width 688px
    z-index 201
    height 446px
    position fixed
    top 50%
    left 50%
    margin-left -344px
    margin-top -223px
    background #fff
    .track_header
      width 100%
      height 42px
      background #1B88EE
      text-indent 1em
      line-height 42px
      font-size 16px
      color #fff
      .track_close
        width 42px
        height 42px
        background url('../../../../assets/images/01/close_icon.png') no-repeat center center
        cursor pointer
        position absolute
        right 0px
        &:hover
          background url('../../../../assets/images/01/tanluang_close.png') no-repeat center center
    .track_main
      width calc(100% - 20px)
      margin 10px auto
      height calc(100% - 62px)
      #track_container
        height 100%
  .el-table td, .el-table th
    vertical-align top
  .el-table__expanded-cell
    padding 0 0 30px
    background #f7f9fb
    &:hover
      background #f7f9fb !important
  .el-table::before
    height 0
    &:hover
      background #f7f9fb !important
  .el-table td, .el-table th.is-leaf
    border-bottom none
</style>
